import React, { useEffect, useState } from "react";
import styled from "styled-components";
import subscriptionService, { ISubscription, SubscriptionType } from "../../services/SubscriptionService";
import { DefaultButton, Spinner, SpinnerSize } from "@fluentui/react";
import { useHistory } from "react-router-dom";
import Auth from "../../Auth/Auth";
import SuscripcionSelector from "../Payments/SuscripcionSelector/SuscripcionSelector";
import { DEFAULT_PLAN } from "../Payments/SuscripcionSelector/util";

export const MainTitle = styled.h2`
    text-align: center;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 1em;
    font-size: 25px !important;
    color: ${(props) => props.theme.palette.black};
    display: block;
`;
export const Description = styled.p`
    margin: 0;
    overflow-y: hidden;
    padding-top: 1em;
    padding-left: 1em;
    padding-right: 1em;
    font-size: 23px;
    text-align: justify;
`;
export const LateralDiv = styled.div`
    background-color: ${(props) => props.theme.palette.greyMorePlans};
    padding-right: 0;
    border-radius: 12px;
    text-overflow: ellipsis;
    height: 700px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;
export const Button = styled(DefaultButton)``;

const ExperienceSavingsPlanDifferentSubscriptions = () =>
{
    const [subscriptions, setSubscriptions] = React.useState<SubscriptionType[]>();
    const isLoading = React.useRef<boolean>(false);
    const areSubscriptionsLoaded = React.useRef<boolean>(false);

    const portfolioAmount = localStorage.getItem('portfolioValue');

    useEffect(() =>
    {
        Auth.deleteExperienceSubscription();
    }, []);

    useEffect(() =>
    {
        if(areSubscriptionsLoaded.current === false)
        {
            areSubscriptionsLoaded.current = true;
            subscriptionService.getSubscriptionsByType("experience").then((response: SubscriptionType[]) =>
            {
                isLoading.current = true;
                const filteredSubscriptions = response.filter(sub => sub.name !== "IronIA Mes a Mes")                        .sort((a, b) => {
                    if (a.limit === null || !a.limit) return 1;
                    if (b.limit === null || !b.limit) return -1;
                    return a.limit - b.limit;
                });
                setSubscriptions(filteredSubscriptions);
            });
        }
    }, [subscriptions]);

    const [selectedPlan, setSelectedPlan] = useState<ISubscription>(DEFAULT_PLAN);
    const history = useHistory();

    const handleContinuar = () => {
        history.push({
            pathname: `/subscription/${selectedPlan.id}`,
            state:
            {
                initialContribution: 0,
                managedPortfolioId: null
            },
        });
    };

    if(isLoading.current === false)
    {
        return (<Spinner size={SpinnerSize.large} />);
    }
    else
    {
        return(
            <React.Fragment>
                <div className="shadow">
                    <SuscripcionSelector
                        subscriptions={subscriptions ?? []}
                        selectedPlan={selectedPlan}
                        currentAmount={portfolioAmount ? JSON.parse(portfolioAmount).portfolioValue : 0}
                        setSelectedPlan={setSelectedPlan} />
					<div className="suscriptionButton__container">
                        <DefaultButton className="button tiny-primary-button"
                            text="Continuar"
                            onClick={handleContinuar}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ExperienceSavingsPlanDifferentSubscriptions;